Ext.define('SA.data.List', {
    mixins: {
        observable: 'Ext.util.Observable'
    },

    constructor() {
        this.mixins.observable.constructor.call(this);
        this.callParent();

        this.index = {};
        this.items = [];
    },

    add(item) {
        var indexField = this.indexField;

        this.items.unshift(item);

        if (indexField != null) {
            this.index[item[indexField]] = item;
        }

        this.fireEvent('change');
    },

    get(id) {
        if (Array.isArray(id)) {
            return id.map(this.get, this);
        }

        if (typeof id === 'object') {
            return id;
        }

        return this.index[id];
    },

    getAll() {
        return this.items;
    },

    remove(id) {
        var index = this.index,
            indexField = this.indexField,
            item;

        if (id && typeof id === 'object') {
            item = id;
        }
        else {
            item = index[id];
        }

        if (item) {
            Ext.Array.remove(this.items, item);

            if (indexField) {
                id = item[indexField];
                delete index[id];
            }
        }

        this.fireEvent('change');
    }
});
